import { User } from "@/core/entities/user";

/**
 * This is a singleton class that stores the user object.
 * @example
 * const userContext = UserContext.getInstance();
 * userContext.setUser(user);
 * const user = userContext.getUser();
 * OR
 * UserContext.getInstance().getUser();
 */
export class UserContext {
  private static instance: UserContext;
  private user?: User;

  private constructor() {}

  static getInstance(): UserContext {
    if (!UserContext.instance) {
      UserContext.instance = new UserContext();
    }
    return UserContext.instance;
  }

  setUser(user: User | null) {
    if (user) {
      this.user = user;
    } else {
      this.user = undefined;
    }
  }

  getUser(): User | undefined {
    return this.user;
  }
}
